export default __webpack_public_path__ + "static/media/mapCloseIcon.f8e64042.svg";